export default __webpack_public_path__ + "static/media/netErr.2cf5229b.svg";